import type { Iso3166Alpha2Lower, LocaleCode, LocaleLanguage } from "../types";

import { isIso3166Alpha2Lower } from "./country-definitions";
import { isLocaleLanguage } from "./is-locale-language";

type ParsedLocaleCode = {
  iso3166Alpha2Lower: Iso3166Alpha2Lower;
  language: LocaleLanguage;
};

function getLocaleCodeForIso3166Alpha2Lower(
  iso3166Alpha2Lower: Iso3166Alpha2Lower,
  language: LocaleLanguage,
): LocaleCode {
  return `${iso3166Alpha2Lower}-${language}` as LocaleCode;
}

function parseLocaleCode(code: LocaleCode): ParsedLocaleCode {
  const [iso3166Alpha2Lower, language] = code.split("-");

  if (!iso3166Alpha2Lower || !language) {
    throw new Error(`Invalid locale code: ${code}`);
  }

  if (!isIso3166Alpha2Lower(iso3166Alpha2Lower)) {
    throw new Error(`Unknown country prefix in locale code: ${code}`);
  }

  if (!isLocaleLanguage(language)) {
    throw new Error(`Unknown language in locale code: ${code}`);
  }

  return { iso3166Alpha2Lower, language };
}

export { getLocaleCodeForIso3166Alpha2Lower, parseLocaleCode };
